import { useQuery } from '@apollo/client';
import { COMPANIES_BY_INDUSTRY_QUERY } from '@/graphql/queries';

type CompaniesByIndustriesProps = {
  limit: number;
  offset: number;
  id: string;
};

const useCompaniesByIndustry = ({
  limit = 4,
  offset = 0,
  id,
}: CompaniesByIndustriesProps) => {
  const variables = { limit, offset, id };
  const { error, ...rest } = useQuery(COMPANIES_BY_INDUSTRY_QUERY, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useCompaniesByIndustry };
